import { jsx as _jsx } from "react/jsx-runtime";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
/**
 * Reusable button wrapper to keep defaults consistent.
 * Use MUI props via passthrough.
 */
export default function AppButton({ children, type = "button", className, variant, color, loading = false, disabled, startIcon, fullWidth, ...props }) {
    // Neutral gray look while disabled (incl. loading); normal look once enabled.
    const mergedClassName = ["app-button-grey-disabled", className]
        .filter(Boolean)
        .join(" ");
    return (_jsx(Button, { type: type, variant: variant, color: color, fullWidth: fullWidth, disableElevation: true, disabled: disabled || loading, className: mergedClassName, startIcon: loading ? _jsx(CircularProgress, { size: 20, color: "inherit" }) : startIcon, ...props, "data-testid": "primary-button", children: children }));
}
